export const locales = ["en-GB","np-NP"]
export const fileNamesByLang = {"en":"en","en-GB":"en","np":"np","np-NP":"np"}/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {"en":"en-GB","en-GB":"en-GB","np":"np-NP","np-NP":"np-NP"}